import AppPage from '@/components/app-page/index.vue';
import Analyze from '../analyze-users';

export default [{
  path: '/user-analysis',
  name: 'userAnalysis',
  component: AppPage,
  meta: {
    title: '用户分析',
    style: 's-data',
  },
  children: [
    {
      path: 'list',
      name: 'userAnalysisList',
      component: () => import('@/views/visualization/user-analysis/index.vue'),
      meta: {
        title: '基础数据',
        style: 'tickets',
        activeMenu: '/user-analysis/list',
        isUseAppInfo: false,
      },
    },
    {
      path: 'added',
      name: 'userAnalysisAdded',
      component: () => import('@/views/visualization/user-analysis/added.vue'),
      meta: {
        title: '新增用户',
        style: 'user',
        activeMenu: '/user-analysis/list',
        isUseAppInfo: false,
      },
    },
    {
      path: 'active',
      name: 'userAnalysisActive',
      component: () => import('@/views/visualization/user-analysis/active.vue'),
      meta: {
        title: '活跃用户',
        style: 'user-solid',
        activeMenu: '/user-analysis/list',
        isUseAppInfo: false,
      },
    },
    {
      path: 'terminal',
      name: 'userAnalysisTerminal',
      component: () => import('@/views/visualization/terminal-analysis/index.vue'),
      meta: {
        title: '终端设备',
        style: 'mobile-phone',
        activeMenu: '/user-analysis/list',
        isUseAppInfo: false,
      },
    },
    {
      path: 'version',
      name: 'userAnalysisVersion',
      component: () => import('@/views/visualization/version-analysis/index.vue'),
      meta: {
        title: '版本分布',
        style: 'pie-chart',
        activeMenu: '/user-analysis/list',
        isUseAppInfo: false,
      },
    },
    ...Analyze,
  ],
}];
